<script setup lang="ts">
import { useReactiveQueryParam } from '@/composables/useReactiveQueryParam'
import { AccountKYCActionTypes, useAccountKycListStore } from '@/modules/account/stores/account.kyc.store.ts'
import AccountDetail from '@/modules/account/views/AccountDetail.vue'
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import FilterList from '@/onenetwork/components/filter/FilterList.vue'
import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import _ from 'lodash'
import { computed, onMounted, watch } from 'vue'
import { useAccountDetailStore } from '../stores/account.detail.store'


const accountKycListStore = useAccountKycListStore()
const accountDetailStore = useAccountDetailStore()


const pageTabs = computed(() => {
  return accountKycListStore.tabs
})
const displayTabContent = computed(() => {
  return accountKycListStore.tabs?.find(tab => tab.active)?.id || 'list'
})
const TableConfig = computed(() => {
  return accountKycListStore.tableConfig
})
const filter = computed(() => {
  return accountKycListStore.filter
})
const loading = computed(() => {
  return accountKycListStore.action_type == AccountKYCActionTypes.FETCHING
})
const page = computed(() => {
  return accountKycListStore.page
})
const pageSize = computed(() => {
  return accountKycListStore.pageSize
})
const dataSource = computed(() => accountKycListStore.data)

const handleChangeTab = (tab: any) => {

  accountKycListStore.changeTab(tab.id)
}

const handleCloseTab = (tab: any) => {

  accountKycListStore.closeTab(tab.id)
}

const handleCloseAllTab = () => {
  accountKycListStore.closeAllTab()
}

const handleChangePage = (page: number) => {

  accountKycListStore.changePage(page)
}

const handleChangePageSize = (size: number) => {

  accountKycListStore.changePageSize(size)
}

const handleUpdateFilter = (filter: any) => {

  accountKycListStore.setFilter(filter)
}

const handleRowDblClick = (e: MouseEvent, item: any) => {

  accountKycListStore.newTab({id: item.user.id, label: `#${item.code} - ${item.full_name}`, active: true})
}

const handleRowClick = (e: MouseEvent, item: any) => {

}

const handleChangeSelectedRow = (ids: Array<string|number>) => {

}

const handleSort = (field: string, direction: string) => {

  accountKycListStore.toggleSort(field, direction)
}

const requestFetchAccountKYCList = _.debounce(async () => {
  try{
    const res = await accountKycListStore.fetchList()
  } catch (e) {

  }
}, 500)

const detailId: any = useReactiveQueryParam('detailId')
const setDetailTab = async () => {
  if(parseInt(detailId.value || 0)){
    try {
      const data: any = await accountDetailStore.fetchAccountDetail(parseInt(detailId.value))
      accountKycListStore.newTab({id: data.id, label: `#${data.code} - ${data.full_name}`, active: true})
    } catch (e: any) {
      console.log(e)
    }
  }
}

watch(()=>detailId, (val) => {
  console.log('Giá trị detailId thay đổi:', val.value)
  if(val.value) setDetailTab()
}, {immediate: true})



watch(()=> accountKycListStore.uuid, (newVal, oldVal) => {
  requestFetchAccountKYCList()
})

onMounted(() => {
  accountKycListStore.changeTab('list')
  requestFetchAccountKYCList()
})

const handleResetFilter = () => {

  accountKycListStore.resetFilter()
  requestFetchAccountKYCList()
}

</script>

<template>
  <dashboard-layout currentRoute="account/kyc" page-title="Yêu cầu phê duyệt KYC" :tabs="pageTabs" :tabsEvent="{
    close: handleCloseTab,
    select: handleChangeTab,
    closeAll: handleCloseAllTab
  }">
    <template v-if="displayTabContent == 'list'">
      <filter-list
        :filter="filter"
        @update:filter="handleUpdateFilter"
        @reset:filter="handleResetFilter"
      />
      <data-table
        :loading="loading"
        :tableConfig="TableConfig"
        :page-size="pageSize"
        :page="page"
        :total-page="dataSource?.totalPage || 0"
        :total-records="dataSource?.totalRecords || 0"
        :data="dataSource.list || []"
        :row-action-buttons="[
          { action: handleRowDblClick, css: 'btn btn-cs', label: 'Chi tiết', icon: 'iconamoon:edit-duotone', perm: 'account.view_info' }
        ]"
        primaryField=""
        @page-changed="handleChangePage"
        @pagesize-changed="handleChangePageSize"
        @toggle-visibility="accountKycListStore.toggleColumnVisibility"
        @on-row-click="handleRowClick"
        @on-row-dblclick="handleRowDblClick"
        @on-selected-row="handleChangeSelectedRow"
        @on-sort="handleSort"
      />
    </template>
    <template v-else>
      <template v-for="tab in pageTabs">
        <template v-if="tab.id == displayTabContent">
          <AccountDetail :id="tab.id" :key="tab.id"/>
        </template>
      </template>
    </template>
  </dashboard-layout>
</template>

<style scoped></style>
